var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TodoEditView',{attrs:{"todo":_vm.todoToEdit,"saving":_vm.saving,"error":_vm.error,"finished":_vm.finished},on:{"saveTodo":_vm.onSaveTodo,"setFinished":_vm.setFinished}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }